import { COLLAB_EMAIL } from '@/config/links'
import { useLanguage } from '@/context/LanguageContext'
import {Handshake} from 'lucide-react'

function Partners() {
  const { t } = useLanguage()

  return (
    <section id="sponsors" className="bg-[#2b1c12] py-14">
      <div className="max-w-md mx-auto px-4">
        <h2 className="text-2xl font-bold text-amber-50 mb-2 text-center">
          {t.partners.title}
        </h2>
        <p className="text-amber-100/70 text-sm text-center leading-relaxed mb-8">
          {t.partners.subtitle}
        </p>

        <div className="flex flex-col gap-4">
          <div
            style={{ animationDelay: '80ms' }}
            className="rounded-2xl bg-[#3d2b1f] p-6 flex flex-col items-center text-center border border-amber-800/30 animate-fade-in-up"
          >
            <Handshake className="w-7 h-7 text-amber-400 mb-3" />
            <h3 className="text-amber-50 font-semibold text-base mb-1">
              {t.partners.collabTitle}
            </h3>
            <p className="text-amber-100/70 text-sm leading-relaxed mb-4">
              {t.partners.collabText}
            </p>
            <a
              href={`mailto:${COLLAB_EMAIL}?subject=${encodeURIComponent('Collaboration avec The Mimi Factory')}`}
              className="px-5 py-2.5 rounded-full bg-amber-500 text-[#2b1c12] font-semibold text-sm hover:bg-amber-400 transition-colors"
            >
              {t.partners.collabCta}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Partners
